/* RL Landing — launch countdown.
   Vanilla, no module. Prefixed globals only.

   The target instant is resolved server-side (Liquid renders an epoch
   in ms into data-rl-countdown-target) so the deadline is the SAME for
   every visitor regardless of their machine's timezone. A shopper in
   Pointe-à-Pitre and one in Paris see the counter hit zero together.

   Markup is fully rendered by Liquid with the correct values already
   in place, so the first paint is never blank and never shifts — this
   script only takes over the per-second increment. If JS never runs,
   the visitor keeps a static but accurate snapshot from render time.

   When the deadline passes the counter is replaced by the section's
   post-launch message (data-rl-countdown-done), and the interval is
   cleared so the page stops ticking for nothing. */
(function () {
  'use strict';

  var RL_COUNTDOWN_SELECTOR = '[data-rl-countdown]';
  var RL_COUNTDOWN_UNITS = ['days', 'hours', 'mins', 'secs'];

  var RL_COUNTDOWN_MS_DAY = 86400000;
  var RL_COUNTDOWN_MS_HOUR = 3600000;
  var RL_COUNTDOWN_MS_MIN = 60000;
  var RL_COUNTDOWN_MS_SEC = 1000;

  function RL_COUNTDOWN_pad(value) {
    return value < 10 ? '0' + value : String(value);
  }

  /* Split a remaining duration into padded day/hour/minute/second parts.
     Days are NOT padded to two digits on purpose: a launch more than
     99 days out would otherwise render a misleading truncated value. */
  function RL_COUNTDOWN_split(remaining) {
    var left = remaining;

    var days = Math.floor(left / RL_COUNTDOWN_MS_DAY);
    left -= days * RL_COUNTDOWN_MS_DAY;

    var hours = Math.floor(left / RL_COUNTDOWN_MS_HOUR);
    left -= hours * RL_COUNTDOWN_MS_HOUR;

    var mins = Math.floor(left / RL_COUNTDOWN_MS_MIN);
    left -= mins * RL_COUNTDOWN_MS_MIN;

    var secs = Math.floor(left / RL_COUNTDOWN_MS_SEC);

    return {
      days: String(days),
      hours: RL_COUNTDOWN_pad(hours),
      mins: RL_COUNTDOWN_pad(mins),
      secs: RL_COUNTDOWN_pad(secs)
    };
  }

  function RL_COUNTDOWN_write(root, parts) {
    for (var i = 0; i < RL_COUNTDOWN_UNITS.length; i++) {
      var unit = RL_COUNTDOWN_UNITS[i];
      var cell = root.querySelector('[data-rl-countdown-unit="' + unit + '"]');
      if (cell && cell.textContent !== parts[unit]) cell.textContent = parts[unit];
    }
  }

  /* Swap the timer for the post-launch message. Both nodes are rendered
     by Liquid, so this is a visibility flip rather than a DOM build. */
  function RL_COUNTDOWN_settle(root) {
    var timer = root.querySelector('[data-rl-countdown-timer]');
    var done = root.querySelector('[data-rl-countdown-done]');

    if (timer) timer.hidden = true;
    if (done) done.hidden = false;

    root.setAttribute('data-rl-countdown-state', 'done');
  }

  function RL_COUNTDOWN_start(root) {
    var target = parseInt(root.getAttribute('data-rl-countdown-target'), 10);
    if (!target || isNaN(target)) return;

    var timerId = null;

    function tick() {
      var remaining = target - Date.now();

      if (remaining <= 0) {
        if (timerId) window.clearInterval(timerId);
        RL_COUNTDOWN_settle(root);
        return;
      }

      RL_COUNTDOWN_write(root, RL_COUNTDOWN_split(remaining));
    }

    tick();
    timerId = window.setInterval(tick, RL_COUNTDOWN_MS_SEC);
  }

  function RL_COUNTDOWN_init() {
    var roots = document.querySelectorAll(RL_COUNTDOWN_SELECTOR);
    for (var i = 0; i < roots.length; i++) RL_COUNTDOWN_start(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', RL_COUNTDOWN_init);
  } else {
    RL_COUNTDOWN_init();
  }

  /* Theme editor re-renders sections without a full page load. */
  document.addEventListener('shopify:section:load', RL_COUNTDOWN_init);
})();
